<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.firstname"
          :label="$t('contact.firstname')"
          type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.lastname"
          :label="$t('contact.lastname')"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="customerSelectItems"
          v-model="item.customer"
          :items="customerSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('qualitycheck.product.customer')"
          item-text="name"
          item-value="@id"
        />
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.email"
          :label="$t('contact.email')"
          type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.phone"
          :label="$t('contact.phone')"
          type="text"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'ContactFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.customerGetSelectItems();
  },

  computed: {
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      customerGetSelectItems: 'customer/fetchSelectItems',
    }),
  }
};
</script>
